import { GrapevineHappeningApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineHappeningApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineHappeningApi(configuration),
    [configuration]
  );
};
